// E2 — create ephemeral session rules (e.g. from E9 auto-test fixes).

import { apiFetch } from './api.js';

/**
 * @param {string} sessionId
 * @param {{ rule: string, source?: 'e9_fix'|'manual' }} input
 */
export async function createSessionRule(sessionId, { rule, source = 'e9_fix' } = {}) {
  if (!sessionId || !rule?.trim()) return { ok: false, error: 'sessionId and rule required' };
  try {
    const res = await apiFetch(`/api/code-ide/sessions/${sessionId}/session-rules`, {
      method: 'POST',
      body: { rule, source },
    });
    if (res.ok) return { ok: true, rule: res.data?.rule };
    return { ok: false, error: res.error || `HTTP ${res.status}` };
  } catch (e) {
    return { ok: false, error: e?.message || String(e) };
  }
}

/** One-line rule text from a failed test summary. */
export function ruleTextFromTestFailure(summary) {
  if (!summary) return '';
  const name = summary.firstFailure?.name || summary.summary?.failed
    ? 'failing tests'
    : 'test failure';
  const err = summary.firstFailure?.error;
  const hint = typeof err === 'string' ? err.split('\n')[0].trim() : '';
  const base = `After a test fix, guard against: ${name}`;
  return hint ? `${base} — ${hint}`.slice(0, 480) : base;
}
